
































































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import { ManagementReportsModule } from '@/store/modules/managementReports';
import { formatCurrency, formatPercent, formatNumber, formatChangePercent } from '@/lib/reportFormatters';
import { ReportMetric } from '@/models/Reports/ManagementReportModels';

@Component({ name: 'ExecutiveReports' })
export default class ExecutiveReports extends GiganautVue {

  comparisonHeaders = [
    { text: 'Metric', value: 'label' },
    { text: 'Current Period', value: 'currentValue', align: 'end' },
    { text: 'Prior Period', value: 'priorValue', align: 'end' },
    { text: 'Change', value: 'change', align: 'end' },
    { text: 'Change %', value: 'changePercent', align: 'end' },
  ];

  leagueHeaders = [
    { text: 'Name', value: 'label' },
    { text: 'Revenue', value: 'revenue', align: 'end' },
    { text: 'GP', value: 'gp', align: 'end' },
    { text: 'Margin', value: 'margin', align: 'end' },
    { text: 'Fill Rate', value: 'fillRate', align: 'end' },
    { text: 'Placements', value: 'placements', align: 'end' },
    { text: 'Activities', value: 'activities', align: 'end' },
  ];

  get executiveSummary() { return ManagementReportsModule.executiveSummary; }
  get periodComparison() { return ManagementReportsModule.periodComparison; }
  get leagueTable() { return ManagementReportsModule.leagueTable; }

  get executiveMetrics() {
    const s = this.executiveSummary;
    if (!s) return [];
    return [
      this.buildMetric(s.revenue, 'currency'),
      this.buildMetric(s.grossProfit, 'currency'),
      this.buildMetric(s.marginPercent, 'percent'),
      this.buildMetric(s.shiftsFilled, 'number'),
      this.buildMetric(s.fillRate, 'percent'),
      this.buildMetric(s.cancellations, 'number'),
      this.buildMetric(s.openJobs, 'number'),
      this.buildMetric(s.placements, 'number'),
      this.buildMetric(s.activities, 'number'),
      this.buildMetric(s.callsConnected, 'number'),
      this.buildMetric(s.newWorkers, 'number'),
      this.buildMetric(s.activeCompanies, 'number'),
    ];
  }

  buildMetric(m: ReportMetric, type: string) {
    let formatted = '';
    if (type === 'currency') formatted = formatCurrency(m.value);
    else if (type === 'percent') formatted = formatPercent(m.value);
    else formatted = formatNumber(m.value);
    return { label: this.relabel(m.label), formatted, changePercent: m.changePercent };
  }

  // The API returns hardcoded "Workers" / "Companies" / "Locations" in metric
  // labels; swap them for the agency's customised terminology client-side so
  // we don't need to plumb labels through the report endpoints.
  relabel(s: string): string {
    if (!s) return s;
    const map: Array<[string, string]> = [
      ['Workers', this.Labels.workers || 'Workers'],
      ['Worker', this.Labels.worker || 'Worker'],
      ['Companies', this.Labels.companies || 'Companies'],
      ['Company', this.Labels.company || 'Company'],
      ['Locations', this.Labels.locations || 'Locations'],
      ['Location', this.Labels.location || 'Location'],
    ];
    let out = s;
    for (const [from, to] of map) {
      // Whole-word replace, case-sensitive — plural runs before singular so
      // "Workers" doesn't get partially matched as "Worker" + trailing "s".
      out = out.replace(new RegExp('\\b' + from + '\\b', 'g'), to);
    }
    return out;
  }

  fmtCurrency(v: number) { return formatCurrency(v); }
  fmtPct(v: number) { return formatPercent(v); }
  fmtNum(v: number) { return formatNumber(v); }
  formatChange(v: number) { return formatChangePercent(v); }
}
